import { eLayoutType, RoutesService } from '@abp/ng.core';
import { eOrchestratorRouteNames } from '../enums/route-names';
import { makeEnvironmentProviders, provideAppInitializer, inject, EnvironmentProviders } from '@angular/core';

export const ORCHESTRATOR_ROUTE_PROVIDERS = [
  provideAppInitializer(() => {
    configureRoutes();
  }),
];

export function configureRoutes() {
  const routes = inject(RoutesService);
  routes.add([
      {
        path: undefined,
        name: eOrchestratorRouteNames.Orchestrator,
        iconClass: 'fas fa-book',
        layout: eLayoutType.application,
        order: 3,
      },
  ]);
}

export const ORCHESTRATOR_PROVIDERS: EnvironmentProviders[] = [
  ...ORCHESTRATOR_ROUTE_PROVIDERS,
];

export function provideOrchestratorConfig() {
  return makeEnvironmentProviders(ORCHESTRATOR_PROVIDERS);
}
